import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import AppContainer from './containers/AppContainer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@nurhanna/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './assets/css/animate.min.css';
import './assets/css/component-form.css';
import './assets/sass/sla-bootstrap-dashboard-react.scss';
// import "bootstrap-daterangepicker/daterangepicker.css";
import './assets/css/daterangepicker.css';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './components/ErrorBoundary';

// Global JS error suppression (unchanged)
window.onerror = function (message, source, lineno, colno, error) {
  const msg = message?.toString() || '';
  const suppressionPatterns = [
    /TypeError/i,
    /undefined is not an object/i,
    /evaluating 'a\.[A-Za-z]+'/i,
  ];
  if (suppressionPatterns.some((pattern) => pattern.test(msg))) {
    console.debug('[Global JS Error Suppressed]', msg);
    return true;
  }
  return false;
};

window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || event?.reason?.toString() || '';
  const suppressionPatterns = [
    /TypeError/i,
    /undefined is not an object/i,
    /evaluating 'a\.[A-Za-z]+'/i,
  ];
  if (suppressionPatterns.some((pattern) => pattern.test(msg))) {
    console.debug('[Unhandled Promise Rejection Suppressed]', msg);
    event.preventDefault();
  }
});

// Initialize store and history
const store = configureStore();
const history = createBrowserHistory();

const container = document.getElementById('root');

if (container) {
  // Handle legacy hash routing redirect (still useful in legacy setups)
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
  if (path) {
    history.replace(path);
  }

  // React 18 root rendering
  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <I18nextProvider i18n={i18next}>
            <AppContainer />
          </I18nextProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>,
  );
}

// Service worker setup
serviceWorker.unregister();
